// extracted by mini-css-extract-plugin
export default {"td_replacement":"TransferClinicWrapper_td_replacement__jNJdh","pending":"TransferClinicWrapper_pending__8ZBAa"};